
import styled from "styled-components";
import { BsInstagram} from "react-icons/bs";
import { FaTiktok, FaFacebookF } from "react-icons/fa";
import { SlSocialYoutube } from "react-icons/sl";



const Media = {
  LaptopLarge: "@media(max-width:1300px)",
  Laptop: "@media(max-width:1220px)",
  LaptopMin: "@media(max-width:1210px)",
  Tablet: "@media(max-width:1000px)",
  Phone: "@media(max-width: 768px)",
};

const SocialContainer = styled.section`
  .sociais {
    position: relative;
    z-index: 9999;
  }

  .cover-social {
    width: 10%;
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    z-index: 9999;
    display: block;
  }

  .cover-social .cover-social-icon {
    position: relative;
    margin-left: 20%;
    z-index: 999;
  }

  li{
    max-width: 50px;
    max-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px auto;
    background-color: var(--branco-color);
    padding: 25px;
    border-radius: 50px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;

    &:hover{
      background-color: #c0b8a8;     
    }
  }

  .github-cover,
  .linkedin-cover,
  .instagram-cover,
  .behance-cover,
  .linktree-cover {
    width: 45px;
    height: 28px;
    display: block;
    margin: 20px 0px;
    position: relative;
    color: var(--verde-color);
    font-size: 31px;
    line-height: 35px;
    border-radius: 50% !important;
    text-align: center;
  }

  ${Media.LaptopLarge} {
    .cover-social {
      display: none;
    }
  }
`;

export default function Social() {
  return (
    <SocialContainer>
      <section className="sociais">
        <section className="cover-social">
          <article className="info-social-cover">
            <aside className="cover-social-container">
              <div className="cover-social-icon">
                <ul>
                  <li>
                    <a
                      aria-label="Facebook do Bàbá King"
                      target="Facebook"
                      without
                      rel="noreferrer"
                      href="https://www.facebook.com/babakingoduduwa/"
                    >
                      <FaFacebookF  className="github-cover" />
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="instagram do Bàbá King"
                      target="instagram"
                      without
                      rel="noreferrer"
                      href="https://www.instagram.com/babakingoduduwa/"
                    >
                      <BsInstagram className="instagram-cover" />
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="TikTok do Bàbá King"
                      target="TikTok"
                      without
                      rel="noreferrer"
                      href="https://www.tiktok.com/@babakingoduduwa"
                    >
                      <FaTiktok className="linkedin-cover" />
                    </a>
                  </li>
                  <li>
                    <a
                      aria-label="Youtube do Oduduwa"
                      target="Youtube"
                      without
                      rel="noreferrer"
                      href="https://www.youtube.com/OduduwaTemplodosOrixas/"
                    >
                      <SlSocialYoutube  className="behance-cover" />
                    </a>
                  </li>
                </ul>
              </div>
            </aside>
          </article>
        </section>
      </section>
    </SocialContainer>
  );
}
